module.exports = __webpack_public_path__ + "static/media/3.86bb5caf.svg";